import React, { useState } from 'react';
import { postflightQuestions } from '../data/postflightQuestions';

const PostflightQuestionnaire = ({ flightDate, onComplete, onSkip }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [responses, setResponses] = useState({});

  const handleAnswer = (answer) => {
    const newResponses = { ...responses, [postflightQuestions.initial[currentQuestion].id]: answer };
    setResponses(newResponses);

    if (currentQuestion < postflightQuestions.initial.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      onComplete(newResponses);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-2xl font-semibold mb-4">Post-Flight Questionnaire</h2>
      <p className="text-gray-600 mb-6">
        Please provide feedback about your flight on {new Date(flightDate).toLocaleDateString()}
      </p>

      <div className="space-y-4">
        <div className="mb-4">
          <p className="font-bold">
            Question {currentQuestion + 1} of {postflightQuestions.initial.length}
          </p>
        </div>

        <p className="text-lg">{postflightQuestions.initial[currentQuestion].text}</p>

        <div className="flex flex-col space-y-2">
          {postflightQuestions.initial[currentQuestion].options ? (
            postflightQuestions.initial[currentQuestion].options.map((option, index) => (
              <button
                key={index}
                onClick={() => handleAnswer(option.value)}
                className="w-full text-left px-4 py-2 rounded-lg bg-blue-50 hover:bg-blue-100"
              >
                {option.text}
              </button>
            ))
          ) : (
            <textarea
              className="w-full border rounded-lg p-2"
              rows={4}
              onChange={(e) => handleAnswer(e.target.value)}
              placeholder="Enter your response..."
            />
          )}
        </div>
      </div>

      <div className="mt-6 flex justify-between">
        <button
          onClick={onSkip}
          className="text-gray-500 hover:text-gray-700"
        >
          Remind me later
        </button>
      </div>
    </div>
  );
};

export default PostflightQuestionnaire; 